<template>
  <v-card elevation="0" class="px-4" :height="($vuetify.breakpoint.xsOnly) ? '315px' : '244px'">

    <v-row class="mb-5">

      <v-col xl="8" lg="9" md="9" sm="10" cols="12">
        <v-radio-group v-model="searcType" row class="pa-0 m-0">
          <v-radio label="Buscar por Profissional" value="0"></v-radio>
          <v-radio label="Buscar por Especialidade" value="1"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col xl="8" lg="9" md="9" sm="10" cols="12" v-if="searcType == '0'">
        <v-autocomplete autocomplete="off"
          v-model="professionalOrSpeciality.professional"
          :loading="professionalLoading"
          :items="professionals"
          :search-input.sync="searchProfessionalSync"
          itemText="name"
          itemValue="id"
          returnObject
          cache-items
          hide-no-data
          label="Profissional"
          hint="Registro Profissional ou Nome"
          persistent-hint
          prependIcon="mdi-magnify"
          outlined dense
          @input="$emit('input', professionalOrSpeciality)"
        ></v-autocomplete>
      </v-col>

      <v-col xl="8" lg="9" md="9" sm="10" cols="12" v-else>
        <mb-autocomplete
          v-model="professionalOrSpeciality.speciality"
          :items="specialities"
          itemText="name"
          itemValue="id"
          returnObject
          name="speciality"
          label="Especialidade"
          hint="ex: Neurologia"
          persistent-hint
          prependIcon="mdi-magnify"
          @input="$emit('input', professionalOrSpeciality)"
        />
      </v-col>
    </v-row>

    <v-container class="pa-0 ma-0">
      <v-row class="pa-0 ma-0">
        <v-col xl="3" lg="3" md="3" sm="3" cols="12" class="pa-0 ma-0">
          <mb-text-button name="cf_pos_continue" label="Continuar"
            :disabled="!professionalOrSpeciality.professional &&
              !professionalOrSpeciality.speciality"
            @click="$emit('click')"
            :primary="false"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import _ from 'lodash';
import MbAutocomplete from '@/components/general/inputs/MbAutocomplete';
import MbTextButton from '@/components/general/buttons/MbTextButton';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data: () => ({
    searcType: '0',
    professionalOrSpeciality: {
      speciality: null,
      professional: null,
    },
    professionals: [],
    professionalLoading: false,
    searchProfessionalSync: null,

    specialities: [],
    specialityLoading: false,
  }),
  created() {
    this.professionalOrSpeciality = this.value;
  },
  methods: {
    searchProfessional(text) {
      this.professionalLoading = true;

      this.$store.dispatch('professionals/searchProfessional', text)
        .then((professionals) => {
          this.professionals = professionals.map((obj) => {
            obj.name = `${obj.document}-${obj.name}`;
            return obj;
          });
        })
        .finally(() => {
          this.professionalLoading = false;
        });
    },
    getScpecialities() {
      this.specialityLoading = true;

      this.$store.dispatch('specialities/get')
        .then((specialities) => {
          this.specialities = specialities;
        })
        .finally(() => {
          this.specialityLoading = false;
        });
    },
  },
  components: {
    MbAutocomplete,
    MbTextButton,
  },
  watch: {
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line func-names
    searchProfessionalSync: _.debounce(function (vl) {
      if (vl && vl.length > 0) {
        this.searchProfessional(vl);
      }
    }, 600),
    searcType(vl) {
      if (vl === '1' && this.specialities.length === 0) {
        this.getScpecialities();
      }
    },
  },
};
</script>
